export const LOCAL_STORAGE_PANEL_WIDTH_KEY = 'sessions-left-panel-width'
export const DEFAULT_PANEL_WIDTH = 400
export const MIN_PANEL_WIDTH = 280
export const MAX_PANEL_WIDTH = 700
